import { SNoop } from '@obvious.tech/util/validation/schemas'
import { defineEntity } from '../../defineEntity'
import { IMission } from '@obvious.tech/constellation'

export const Mission = defineEntity('Mission', {
  endpoint: 'missions/api/Mission',
  schema: SNoop<IMission>(),
})
